export default "__VITE_ASSET__BO1ae_AC__"